<template>
    <div class="completion-page">
        <div class="construction-status">
            <!--     房屋信息       -->
            <div class="room-basic-info-content">
                <!--        业主信息        -->
                <div class="owner-info">
                    <div v-if="objState == 2" class="img uncourse"></div>
                    <div v-if="objState == 3" class="img working"></div>
                    <div v-if="objState == 4" class="img unfinished"></div>
                    <!-- <img :src="require('@/assets/images/user/house/completion-working-icon.png')" alt="" class="head-image"> -->
                    <div class="text-content ">
                        <!-- {{objUserHouseInfo}} -->
                        <p class="address" style="word-wrap:break-word;">{{ objUserHouseInfo.new_name }}</p>
                        <p class="name">
                            <span class="first">{{ objUserHouseInfo.name }}</span>
                            <!-- <span>{{ 'NO.2021080907655' }}</span> -->
                        </p>
                    </div>
                </div>
                <!--        房屋信息        -->
                <div class="room-info">
                    <div class="room-info-item">
                        <p class="key">户型</p>
                        <p class="value">{{ objUserHouseInfo.new_roomnumber ? objUserHouseInfo.new_roomnumber + '室' : ''
                        }}{{ objUserHouseInfo.new_hall ? objUserHouseInfo.new_hall + '厅' : '' }}{{
        objUserHouseInfo.new_toilet ? objUserHouseInfo.new_toilet + '卫' : ''
}}{{
        objUserHouseInfo.new_kitchen ? objUserHouseInfo.new_kitchen + '厨' : ''
}}</p>
                    </div>
                    <div class="room-info-item">
                        <p class="key">面积</p>
                        <p class="value">{{ objUserHouseInfo.new_area }} ㎡</p>
                    </div>
                    <div class="room-info-item">
                        <p class="key">房屋类型</p>
                        <p class="value">{{ newHousetypeName }}</p>
                    </div>
                    <div class="room-info-item">
                        <p class="key">系统产品</p>
                        <p class="value">冷暖风水</p>
                    </div>
                </div>

                <!--        悬浮标签        -->
                <!-- <div class="abs-tag">{{ '空调壁挂炉' }}</div> -->
            </div>
            <!--     状态信息       -->
            <div class="status-info-content">
                <div class="status-item"
                    :class="[item.fin_status == 2 ? 'status-item-active' : item.fin_status == 1 ? 'status-item-active-shigong' : '']"
                    v-for="(item, index) in arrConstStateList" :key="item.state">
                    <p class="status-name">{{ item.status_name }}</p>
                    <div class="statu-image">
                        <img :src="require('@/assets/images/user/house/project-team-finish-icon.png')"
                            v-if="item.fin_status == 2" alt="">
                        <img :src="require('@/assets/images/user/house/finish_icon_n_sg.png')"
                            v-else-if="item.fin_status == 1" alt="">
                        <img :src="require('@/assets/images/user/house/project-team-finish-no-icon.png')" v-else alt="">
                        <div class="xian" v-if="index != arrConstStateList.length - 1"></div>
                    </div>
                    <p class="status-text" :class="{ 'len-status-text': item.process_name.split('').length > 4 }">{{
                            item.process_name
                    }}</p>
                </div>
            </div>
        </div>
        <!--     报告标题    -->
        <!-- <img :src="require('@/assets/images/user/house/completion-tip-icon.png')" alt="" class="icon"> -->
        <!-- <p>{{ objUserHouseInfo.new_name }}</p> -->
        <!-- <div @click="changeReportSwitchPopupVisible" class="report-name">
            <p>冷暖风水系统施工交付报告</p>
        </div> -->

        <!--    报告列表    -->
        <div class="report-list-wrap">
            <div class="report-item" v-for="(report, rIndex) in arrReportList" :key="rIndex"
                @click.stop="$router.push({ path: '/member/process/detail', query: { state: report.state, id: report.id, type: report.is_completed } })">
                <!--        报告标题        -->
                <!-- :class="{'wait-title-content' :  report.state === 1,'confirm-title-content':  report.state === 2}" -->
                <div class="title-content confirm-title-content">
                    <p class="context">{{ report.title }}</p>
                    <!-- <div class="status-btn">{{ report.state === 1 ? '待确认' : report.state === 2 ? '已确认' : '待交付' }}</div> -->
                </div>
                <!--       报告展示内容         -->
                <div class="show-content" v-if="report.state !== 3">
                    <!--           图片信息         -->
                    <div class="image-list">
                        <div class="image-ovflow">
                            <div class="images">
                                <div class="image" v-for="(image, imgIndex) in report.attach" :key="imgIndex" alt="">
                                    <img :src="image.image_url" alt="">
                                </div>
                            </div>
                        </div>
                        <!--        附加内容        -->
                        <div class="pro-info">
                            <!--        合格标识        -->
                            <!-- <img v-if="report.state === 2" class="confirm-icon" :src="require('@/assets/images/user/house/completion-working-confirm-icon.png')" alt=""> -->
                            <!--       检验信息        -->
                            <!-- <div v-if="report.state === 1" class="programs">
                                <p>{{ report.tag_total }}个工序</p>
                                <p>{{ report.control_total }}个质控点</p>
                            </div> -->
                        </div>
                    </div>
                    <!--        评论信息            -->
                    <div v-if="report.report_appraise.hasOwnProperty('id')" class="eva-context-info">
                        <div class="title">
                            <p>我的评价</p>
                            <img :src="require('@/assets/images/user/house/completion-star-icon.png')"
                                v-for="item in Number(report.report_appraise.score)" :key="item" alt="">
                        </div>
                        <div class="tags">
                            <div class="tags_item" v-for="(tags, tagNum) in report.report_appraise.tag_name"
                                :key="tagNum">{{ tags }}</div>
                        </div>
                        <p class="eva-text">{{ report.report_appraise.desc }}</p>
                    </div>
                    <!--         操作按钮           -->
                    <div class="action-btn">
                        <div @click.stop="changeConfirmPopupVisible(report, report.title, report.id)"
                            v-if="!report.report_appraise.hasOwnProperty('id') && report.is_completed == 0"
                            class="action-item">
                            <img class="icon" :src="require('@/assets/images/user/house/completion-confrim-icon.png')"
                                alt="">
                            <p class="text confirm">我要评价</p>
                        </div>
                        <div @click.stop="changeConfirmPopupVisible(report, report.title, report.id)"
                            v-if="report.state != 2 && report.is_completed != 0" class="action-item">
                            <img class="icon" :src="require('@/assets/images/user/house/completion-confrim-icon.png')"
                                alt="">
                            <p class="text confirm">竣工验收</p>
                        </div>
                        <div class="action-item" @click.stop="goDetails(report)">
                            <img class="icon"
                                :src="require('@/assets/images/user/house/completion-confrim-ok-icon.png')" alt="">
                            <p class="text">查看详情</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!--     确认验收弹窗      -->
        <Popup v-model="bConfirmPopupVisible" class="confirm-cover-popup">
            <!--            标题      -->
            <p class="title">{{ `对本次${rpertTitle}的验收是否满意` }}</p>
            <!-- <p class="star-text">{{ '非常满意，无可挑剔' }}</p> -->
            <startEvaluate @scoreChange="scoreChange"></startEvaluate>
            <!--     标签       -->
            <div class="tags-content">
                <div @click="changeTagActive(tag.id)" v-for="(tag, tagIndex) in arrAcceptance" :key="tagIndex"
                    class="tags-item" :class="{ 'tags-item-active': arrAcceptanceActive.includes(tag.id) }">
                    <p>{{ tag.name }}</p>
                    <!-- <img v-if="arrAcceptanceActive.includes(tag.id)" class="active-icon" :src="require('@/assets/images/user/house/completion-select-icon.png')" alt=""> -->
                </div>
            </div>
            <!--    文本输入控件       -->
            <textarea class="text-input" placeholder="其他想说的：" v-model="tagsText" />
            <!--        提交按钮    -->
            <div class="commit-button" @click="getMemberAppraise">提交评价</div>
        </Popup>

        <!--    报告选择弹窗     -->
        <Popup position="bottom" v-model="bReportSwitchVisible" class="report-switch-popup">
            <VantPicker :columns="arrReportNameList" value-key="title" show-toolbar @confirm="reportPickerConfirm"
                @cancel="changeReportSwitchPopupVisible" />
        </Popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Popup, Picker } from "vant";
import startEvaluate from "@/page/service/components/startevaluate";
import oDeliver from "@/js/deliver.js";

export default {
    name: "completion",
    data() {
        return {
            rpertTitle: '',//评价弹窗标题
            // 用户房屋信息
            objUserHouseInfo: {},
            // 项目的状态数组
            arrConstStateList: [
                {
                    process_name: "",
                },
            ],
            // 确认验收弹窗显示
            bConfirmPopupVisible: false,
            // 报告选择弹窗
            bReportSwitchVisible: false,
            // 验收服务项
            arrAcceptance: [],
            // tag评分星星
            nUserScore: 5,
            // 评分文字
            tagsText: "",
            // 报告id
            reportId: 0,
            // 验收项激活
            arrAcceptanceActive: [],
            newHousetypeName: "", //户型
            objState: 0,
        };
    },
    components: {
        Popup,
        VantPicker: Picker,
        startEvaluate,
    },
    computed: {
        ...mapState({
            // 报告列表
            arrReportList: (state) => state.userHouseCompletion.arrReportList,
            // 主报表切换列表
            arrReportNameList: (state) =>
                state.userHouseCompletion.arrReportNameList,
        }),
        // 当前激活的主报告
        activeReportName() {
            return this.$store.getters["userHouseCompletion/activeReportName"];
        },

    },
    created() {

        let _that = this;
        $init(() => {

            _that.getMeberLists();
            _that.getMemberTag();


        });
    },
    methods: {
        // 提交评价
        getMemberAppraise() {
            let _that = this;
            if (_that.nUserScore <= 3 && _that.tagsText == "") {
                _that.$toast({
                    message: "请填写评语",
                    duration: 1000,
                });
                return false;
            }
            _that.$store.commit("loadSwitch", true);
            let objData = {
                report_id: _that.reportId,
                score: _that.nUserScore,
                desc: _that.tagsText,
                tag_id: _that.arrAcceptanceActive.join(","),
            };
            oDeliver.getMemberAppraise(objData).then((res) => {
                _that.$toast({
                    message: "提交成功",
                    duration: 1000,
                });
                _that.$store.commit("loadSwitch", false);
                _that.bConfirmPopupVisible = false;
                _that.getMeberLists();
            });
        },
        // 获取星星评价
        scoreChange(e) {
            this.nUserScore = e;
            this.getMemberTag();
        },
        // 评价tag
        getMemberTag() {
            let _that = this;
            oDeliver.getMemberTag({ rank: _that.nUserScore }).then((res) => {
                _that.arrAcceptance = res.result;
            });
        },
        // 交付列表
        getMeberLists() {
            let _that = this;
            _that.$store.commit("loadSwitch", true);
            oDeliver
                .getMeberLists({
                    projectmgnid: _that.$route.query.projectmgnid,
                })
                .then((res) => {
                    _that.$store.commit("loadSwitch", false);
                    // 户型
                    _that.newHousetypeName =
                        res.result.project.new_housetype_name;
                    // 报告基础信息
                    _that.objUserHouseInfo = res.result.project.project;
                    // 施工流程
                    _that.arrConstStateList = res.result.report_plan;
                    _that.objState = res.result.contract.new_status; // 合同状态
                    console.log(_that.objState)
                    // 当前报告列表
                    _that.$store.state.userHouseCompletion.arrReportList =
                        res.result.report;
                    // 当前激活的主报告
                    _that.$store.state.userHouseCompletion.sActiveReportId =
                        res.result.report[0].id;
                });
        },
        /**
         * 改变验收弹窗显示
         */
        changeConfirmPopupVisible(report, title, id) {
            if (!this.bConfirmPopupVisible) {
                this.reportId = id;
                this.rpertTitle = title;
            }
            if (report.is_completed == 0) {
                this.bConfirmPopupVisible = !this.bConfirmPopupVisible;
                this.arrAcceptanceActive = [];
            } else {
                window.location.href = `${window.location.origin}/member/process/detail?state=${report.state}&id=${report.id}`
            }
        },
        // 跳转详情
        goDetails(report) {
            window.location.href = `${window.location.origin}/member/process/detail?state=${report.state}&id=${report.id}`
        },
        /**
         * 改变验收激活项员素
         * @param {string} tag
         */
        changeTagActive(tag) {
            this.arrAcceptanceActive.includes(tag)
                ? (this.arrAcceptanceActive = this.arrAcceptanceActive.filter(
                    (i) => i !== tag
                ))
                : this.arrAcceptanceActive.push(tag);
        },
        /**
         * 改变报告选择弹窗显示
         */
        changeReportSwitchPopupVisible() {
            // this.bReportSwitchVisible = !this.bReportSwitchVisible;
        },
        /**
         * 主报告选择器确认
         * @param id
         */
        reportPickerConfirm({ id }) {
            this.$store.commit({
                type: "userHouseCompletion/CHANGE_REPORT_ACTIVE_ID",
                id,
            });
            // this.changeReportSwitchPopupVisible();
        },

    },
};
</script>

<style scoped lang="scss">
::v-deep .van-overlay {
    z-index: 99 !important;
}

.img {
    margin: 0 4px;
    width: 132px;
    height: 132px;
}

.working {
    background: url("~@/assets/images/user/house/working_icon.png") no-repeat center/100% 100%;
}

.unfinished {
    background: url("~@/assets/images/user/house/unfinished.png") no-repeat center/100% 100%;
}

.uncourse {
    background: url("~@/assets/images/user/house/uncourse.png") no-repeat center/100% 100%;
}

.completion-page {
    background: $defaultBackgroundGary;
    min-height: 100vh;
    padding: 28px 24px 32px;
    font-size: $baseSize;

    .construction-status {
        border-radius: $commonRadius;
        margin-bottom: 28px;
        overflow: hidden;
        font-size: $smallSize;
        color: #ffffff;

        .room-basic-info-content {
            background: $deepGreen;
            padding: 16px 0 28px;
            position: relative;

            .abs-tag {
                width: 160px;
                height: 44px;
                background: #81c169;
                line-height: 44px;
                text-align: center;
                position: absolute;
                right: 0;
                top: 0;
                border-bottom-left-radius: $commonRadius;
            }

            .owner-info {
                padding: 0 4px;
                justify-content: space-between;
                align-items: center;
                display: flex;
                margin-bottom: 24px;

                .head-image {
                    flex: 0;
                    width: 132px;
                    height: 132px;
                    margin-right: 4px;
                }

                .text-content {
                    // flex: 1;
                    width: 77%;
                    padding: 16px 0;

                    .address {
                        word-wrap: break-word;
                        width: 100%;
                        // white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 36px;
                        font-weight: 500;
                        line-height: 50px;
                        margin-bottom: 10px;
                    }

                    .name {
                        line-height: 40px;
                        color: #ffe56e;
                        display: flex;
                        align-items: center;

                        .first {
                            font-size: $baseSize;
                            margin-right: 16px;
                            color: rgba(#ffffff, 0.8);
                        }
                    }
                }
            }

            .room-info {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .room-info-item {
                    flex: 0 0 25%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .key {
                        line-height: 36px;
                        color: rgba(#ffffff, 0.6);
                        margin-bottom: 16px;
                    }

                    .value {
                        line-height: 32px;
                    }
                }
            }
        }

        .status-info-content {
            display: flex;
            // align-items: center;
            // justify-content: center;
            padding: 28px 0;
            // background: linear-gradient(#fff, #fff) no-repeat left 46px / 70px
            //         10px,
            //     linear-gradient(#fff, #fff) no-repeat right 46px / 70px 10px,
            //     linear-gradient(to right, #c8e1ce 50%, transparent 50%) repeat-x
            //         left 46px / 12px 2px;
            background-color: #ffffff;
            overflow: auto;

            .status-item {
                position: relative;
                flex: 1;
                color: #a2a2a2;
                display: flex;
                flex-direction: column;
                // justify-content: center;
                align-items: center;

                .statu-image {
                    width: 36px;
                    height: 36px;
                    margin-bottom: 14px;

                    img {
                        position: relative;
                        z-index: 1;
                        width: 100%;
                        height: 100%;
                    }

                    .xian {
                        position: absolute;
                        border: 1px dashed #c8e1ce;
                        height: 1px;
                        width: 100%;
                        top: 60px;
                        z-index: 0;
                    }
                }

                .icon {
                    width: 36px;
                    height: 36px;
                    margin-bottom: 14px;
                }

                .status-text {
                    width: 50px;
                    line-height: 34px;
                    text-align: center;
                }

                .len-status-text {
                    width: 78px;
                }

                .status-name {
                    margin-bottom: 14px;
                }
            }

            .status-item-active {
                color: #649559;
            }

            .status-item-active-shigong {
                color: #E3A751;
            }
        }
    }

    .report-name {
        padding: 26px 24px;
        background: #ffffff;
        line-height: 40px;
        border-radius: $commonRadius;
        color: $deepGreen;
        font-size: $baseSize;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;

        p {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .icon {
            width: 28px;
            height: 28px;
            margin-left: 28px;
        }
    }

    .report-list-wrap {
        .report-item {
            margin-bottom: 24px;
            border-radius: $commonRadius;
            overflow: hidden;

            .title-content {
                background: #6c9276;
                height: 100px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-left: 28px;
                border-radius: $commonRadius;
                color: #6c9276;

                .context {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 100%;
                    color: #ffffff;
                    font-size: $bigSize;
                    font-weight: 500;
                }

                .status-btn {
                    width: 114px;
                    height: 44px;
                    border-radius: 44px;
                    line-height: 44px;
                    font-size: $smallSize;
                    text-align: center;
                    background: #ffffff;
                    margin: 0 24px;
                }
            }

            .wait-title-content {
                background: #e3a751;
                color: #e3a751;
            }

            .confirm-title-content {
                background: $greenGradient;
                color: $deepGreen;
            }

            .show-content {
                background: #ffffff;
                padding: 0 24px;

                .image-list {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 28px 0 32px;

                    background: linear-gradient(to right,
                            #f1f1f1 50%,
                            transparent 50%) repeat-x left bottom / 16px 2px;
                    position: relative;
                    margin-bottom: 26px;

                    .image-ovflow {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        overflow: auto;
                    }

                    .images {
                        flex: 1;
                        height: 120px;
                        display: flex;
                        align-items: center;

                        .image {
                            width: 120px;
                            height: 120px;
                            margin-right: 24px;
                            border-radius: $commonRadius;
                            background: #f7f7f7;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            overflow: hidden;

                            image {
                                width: 100%;
                            }
                        }
                    }

                    .pro-info {
                        position: absolute;
                        min-width: 160px;
                        right: 0;
                        top: 10px;

                        .confirm-icon {
                            width: 160px;
                            height: 160px;
                        }

                        .programs {
                            color: #e3a751;
                            width: 186px;
                            margin-top: 34px;

                            p {
                                line-height: 40px;

                                &:first-child {
                                    margin-bottom: 10px;
                                }
                            }
                        }
                    }
                }

                .eva-context-info {
                    background: linear-gradient(to right,
                            #f1f1f1 50%,
                            transparent 50%) repeat-x left bottom / 16px 2px;
                    padding-bottom: 34px;
                    margin-bottom: 28px;

                    .tags {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;

                        // margin-bottom: 20px;
                        .tags_item {
                            padding: 5px 10px;
                            box-sizing: border-box;
                            border-radius: 8px;
                            border: 2px solid rgba(49, 133, 68, 0.3);
                            color: #3d8f50;
                            font-size: 24px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                        }
                    }

                    .title {
                        display: flex;
                        align-items: center;
                        margin-bottom: 16px;

                        & :first-child {
                            line-height: 40px;
                            margin-right: 24px;
                        }

                        img {
                            width: 32px;
                            height: 32px;
                            margin-right: 16px;
                        }
                    }

                    .eva-text {
                        line-height: 32px;
                        color: #a2a2a2;
                    }
                }

                .action-btn {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    color: #a2a2a2;

                    .action-item {
                        display: flex;
                        align-items: center;
                        margin-bottom: 28px;

                        .text {
                            line-height: 40px;
                        }

                        .confirm {
                            color: $deepGreen;
                        }

                        .icon {
                            width: 36px;
                            height: 36px;
                            margin-right: 8px;
                            margin-left: 40px;
                        }
                    }
                }
            }
        }
    }

    .confirm-cover-popup {
        width: 580px;
        // height: 790px;
        border-radius: $commonRadius;
        background: #ffffff;
        padding: 40px 24px 32px;
        z-index: 100 !important;

        .title {
            color: $commonTitle;
            font-weight: 500;
            margin-bottom: 28px;
            line-height: 40px;
            text-align: center;
        }

        .star-text {
            color: #eb6f56;
            font-weight: 500;
            margin-bottom: 12px;
            line-height: 40px;
            text-align: center;
        }

        .tags-content {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 8px;

            .tags-item {
                width: 256px;
                height: 80px;
                border: 2px solid #858585;
                border-radius: $commonRadius;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #858585;
                position: relative;
                margin-bottom: 20px;

                .active-icon {
                    width: 36px;
                    height: 36px;
                    position: absolute;
                    right: 12px;
                }
            }

            .tags-item-active {
                color: #fff;
                border-color: $deepGreen;
                background: $deepGreen;
            }
        }

        .text-input {
            height: 194px;
            padding: 24px 20px;
            background: #f7f7f7;
            border-radius: $commonRadius;
            width: 100%;
            resize: none;
            margin-bottom: 28px;
        }

        .commit-button {
            width: 532px;
            height: 92px;
            background: $greenGradient;
            border-radius: $commonRadius;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-weight: 500;
            font-size: $bigSize;
        }
    }

    .report-switch-popup {
        border-radius: $commonRadius $commonRadius 0 0;
    }

}
</style>
